import { ProductHeroBannerModel } from '../components/productHeroBanner/models/productHeroBanner.model';
import { ProductHeroBannerSeriesDetailModel } from '../components/productHeroBannerSeriesDetail/models/productHeroBannerSeriesDetail.model';
import useSitecoreContext from './useSitecoreContext';

const useHeroBanner = (): boolean => {
  const {sitecoreContext} = useSitecoreContext();
  const componentList = sitecoreContext?.route?.placeholders['jss-main'] as any[];
  const heroBannerCompIndex = componentList.findIndex(
    (item) =>
      item.componentName === 'ProductHeroBannerSeriesDetail' ||
      item.componentName === 'ProductHeroBanner' ||
      item.componentName === 'HeroBanner'
  );
  const heroBannerData = componentList?.[heroBannerCompIndex];

  if (heroBannerData?.componentName === 'ProductHeroBannerSeriesDetail') {
    const sdHeroBannerModel = new ProductHeroBannerSeriesDetailModel(componentList[heroBannerCompIndex]);
    return !!(
      sdHeroBannerModel?.rendition_desktop_size1900?.url ||
      sdHeroBannerModel?.rendition_desktop_size1200?.url ||
      sdHeroBannerModel?.rendition_tablet_size1200?.url ||
      sdHeroBannerModel?.rendition_tablet_size1000?.url ||
      sdHeroBannerModel?.rendition_mobile_size1100?.url
    );
  }

  if (heroBannerData?.componentName === 'ProductHeroBanner') {
    const pHeroBannerModel = new ProductHeroBannerModel(componentList[heroBannerCompIndex]);
    return !!(
      pHeroBannerModel?.desktopRendition?.url ||
      pHeroBannerModel?.desktopSDRendition?.url ||
      pHeroBannerModel?.tabletRendition?.url ||
      pHeroBannerModel?.tabletLandscapeRendition?.url ||
      pHeroBannerModel?.mobileRendition?.url
    );
  }

  return heroBannerCompIndex > -1;
};

export default useHeroBanner;
